const DURACION_TURNO_MIN = 30;

export function getCoberturaParaServicio(plan, servicioId) {
    if (!plan?.coberturas?.length) return null;
    return (
        plan.coberturas.find(
            (c) => String(c.servicio?._id || c.servicio?.id || c.servicio) === String(servicioId)
        ) || null
    );
}

export function calcularCostoConCobertura(servicio, cobertura) {
    const costoBase = servicio.costoConsulta ?? 0;
    if (!cobertura) {
        return { costoFinal: costoBase, nivel: "NO_CUBIERTA", ahorro: 0 };
    }
    const nivel = cobertura.nivelCobertura;
    if (nivel === "TOTAL") {
        return { costoFinal: 0, nivel, ahorro: costoBase };
    }
    if (nivel === "PARCIAL") {
        const porcentaje = cobertura.porcentaje ?? 0; // 0..1
        const tarifaFija = cobertura.tarifaFija ?? 0;
        const cubierto = costoBase * porcentaje;
        const abonaElPaciente = Math.max(0, costoBase - cubierto - tarifaFija);
        return { costoFinal: abonaElPaciente, nivel, ahorro: costoBase - abonaElPaciente };
    }
    return { costoFinal: costoBase, nivel: "NO_CUBIERTA", ahorro: 0 };
}

export function calcularTurnosNecesarios(serviciosSeleccionados) {
    const totalMinutos = serviciosSeleccionados.reduce(
        (acc, s) => acc + (s.duracionEnMinutos ?? 30),
        0
    );
    return Math.ceil(totalMinutos / DURACION_TURNO_MIN);
}